import React, { useState, useEffect } from 'react';
import css from './DeviceSelection.module.scss';
import { useDispatch } from 'react-redux';
import { actions, useSelector } from '../store';
import { selectEndpoint, selectLine } from '../store/reducers/janus';

export default function DeviceSelection() {
    const dispatch = useDispatch()
    const [devices, setDevices] = useState<{ id: string, displayName: string }[]>([])

    useEffect(() => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const d = devices.filter(info => info.kind === 'audiooutput').map(info => ({ id: info.deviceId, displayName: info.label }))
                setDevices([{ id: '', displayName: 'No Secondary Ringer'}, ...d])
            })
            .catch(reason => {
                console.error('failed to enumerate devices', reason)
            })
    }, [])

    return <div>
        <div className={css.deviceSelectionContainer}>
            <h2>Devices</h2>
            <h3>Secondary Ringer Device</h3>
            <select id='secondaryRingerAudioDeviceId' onChange={e => {
                console.info('onchanged called', e.currentTarget.value)
                dispatch(actions.configureSecondaryRinger(e.currentTarget.value))
            }}>
                {devices.map(device => (<option key={device.id} value={device.id}>{device.displayName}</option>))}
            </select>
        </div>
    </div>
}